/**
 * @generated SignedSource<<4f7afa86052f404ee8050cf4cc207490>>
 * @relayHash 618925ecd171e10c47bc48fb1f7155a3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 18a0da3d4a018599a3b7e9bcb64ed2b338d1a980eef545cd22752ab239e174df

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CcpEntitlementIdQuery$variables = Record<PropertyKey, never>;
export type CcpEntitlementIdQuery$data = {
  readonly confluence_tenantContext: {
    readonly licenseStates: {
      readonly confluence: {
        readonly ccpEntitlementId: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CcpEntitlementIdQuery = {
  response: CcpEntitlementIdQuery$data;
  variables: CcpEntitlementIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicenseStates",
        "kind": "LinkedField",
        "name": "licenseStates",
        "plural": false,
        "selections": [
          {
            "concreteType": "LicenseState",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "CcpEntitlementIdQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CcpEntitlementIdQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "618925ecd171e10c47bc48fb1f7155a3",
    "id": "18a0da3d4a018599a3b7e9bcb64ed2b338d1a980eef545cd22752ab239e174df",
    "metadata": {},
    "name": "CcpEntitlementIdQuery",
    "operationKind": "query",
    "text": "query CcpEntitlementIdQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}}}"
  }
};
})();

(node as any).hash = "3800703c56d88a50d87f006b3cc20b97";

export default node;
